import { Asset } from 'contentful'
import { Button } from '~/components/general/Button'
import { FlexContainer } from '~/components/Grid'
import { createOptimizedContentfulImage } from '~/libs/contentful/helpers'
import { TypeHomePageBlock } from '~/types/contentful'
import { trackEvent } from '~/utils/tracking'

type ResumeTemplatesProps = {
  section: TypeHomePageBlock<'WITHOUT_UNRESOLVABLE_LINKS', string>
}

export const ResumeTemplates = ({ section }: ResumeTemplatesProps) => {
  const data = section.fields

  const handleCTABtnClick = () => {
    trackEvent('homepage_click_cta', {
      block: data.blockId,
      target: data.buttonLink as string,
      homepage_CTA: data.buttonName as string,
    })
  }

  return (
    <>
      <section
        data-block-id={data.blockId}
        className={
          'my-25 -mx-8 max-xl:px-11 max-lg:my-15 max-lg:-mx-6 max-md:px-4 max-md:pt-11 max-md:pb-17 animate-templates-trigger'
        }
      >
        <FlexContainer
          flexWrap={'nowrap'}
          justify={'between'}
          style={{ position: 'relative' }}
          className="max-md:max-h-[492px] bg-neutral-25 max-h-[572px] max-md:flex-col max-md:justify-start max-lg:max-h-none rounded-3xl overflow-hidden"
        >
          <FlexContainer
            flexWrap={'nowrap'}
            className="max-w-[378px] lg:!m-[110px_0_0_72px] relative flex-col gap-8 items-start max-md:!m-0 max-md:gap-4 max-md:items-center max-md:!p-8 max-md:!pb-2 max-lg:!m-15 max-lg:!mr-0"
          >
            <h2 className="text-l">{data.title}</h2>
            <p className="text-s max-md:hidden">{data.description}</p>

            <Button
              text={data.buttonName}
              type={'link'}
              href={data.buttonLink}
              onClick={handleCTABtnClick}
              className={'w-fit'}
            />
          </FlexContainer>
          <div className="h-full text-right max-lg:mt-auto max-lg:flex max-md:h-[335px]">
            {data.images && (
              <video
                className="object-cover max-h-full w-full"
                src={createOptimizedContentfulImage(
                  {
                    file: (data.images[0] as Asset<'WITHOUT_UNRESOLVABLE_LINKS', string>).fields
                      .file!,
                  },
                  { quality: 80 },
                )}
                playsInline
                autoPlay
                muted
                loop
              />
            )}
          </div>
        </FlexContainer>
      </section>
    </>
  )
}
